import { createContext } from 'react';
export const FormJSONCreateContext = createContext(null);